<template>
  <div style="height:100%;width:100%;padding: 1em;">
    <div style="width: 100%;height: 90vh;overflow: scroll;padding: 0 0.5em;overflow-x: hidden;" id="prescriptions-modal">
      <div class="col-12" style="padding: 0px;">
        <div class="row d-block d-md-block d-lg-none">
          <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
            <div>
              <div class="col-12" style="padding: 0px;">
                <div class="row">
                  <div class="col-2">
                    <i class="el-icon-tickets prescription-icon"></i>
                  </div>
                  <div @click="$store.commit('setState', {
                      stateName: 'selectedPrescription',
                      stateValue: prescription,
                    });$router.push('selectedprescriptionforreminders')" class="col-10" style="padding: 0px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    <p class="card-heading reason" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{ prescription.reason }}
                    </p>
                    <p class="card-heading mb-0" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{ $t("message.Dr") }}.
                      {{ prescription.provider.firstName }}
                      {{ prescription.provider.lastName }}
                    </p>
                    <p class="card-heading mb-1" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{
                                        getFormattedDate(prescription.created)
                                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="historicPrescriptions.length < 1" class="col-12 text-center">
            <i class="fa fa-info-circle"></i>
            {{ $t("message.No Prescriptions available") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      historicPrescriptions: [],
    };
  },
  async mounted() {
    try {
      this.historicPrescriptions = (
        await this.$store.dispatch("getPrescriptionsHistory", {
          patientId: this.user.patientId,
        })
      ).data;
      console.log(this.historicPrescriptions);
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
  },
};
</script>

<style scoped>
/deep/ #reminders .card-body {
  padding: 15px;
}
#prescriptions-modal .prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
#prescriptions-modal .prescription-list:first-child {
  border-top: none;
}
#prescriptions-modal .prescription-list.selected {
  background-color: whitesmoke;
}
#prescriptions-modal .prescription-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}
#prescriptions-modal .reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}
#prescriptions-modal p {
  line-height: 1.5em;
}
</style>
